import { GridColDef } from '@material-ui/data-grid';

export const ColumnAtivo: GridColDef = {
  headerName: 'Ativo',
  field: 'ativo',
  width: 120,
  type: 'boolean',
};

export const ColumnCodigo: GridColDef = {
  field: 'codigo',
  headerName: 'Código',
  width: 124,
  type: 'number',
};

export const ColumnInscricaoEstatual: GridColDef = {
  field: 'inscricao_estatual',
  headerName: 'Inscrição estadual',
  width: 200,
};

export const ColumnInscricaoMunicipal: GridColDef = {
  field: 'inscricao_municipal',
  headerName: 'Inscrição municipal',
  width: 200,
};

export const ColumnNome: GridColDef = {
  field: 'nome',
  headerName: 'Nome',
  width: 500,
};

export const ColumnNomeFantasia: GridColDef = {
  field: 'nome_fantasia',
  headerName: 'Nome fantasia',
  width: 500,
};

export const ColumnTipoPessoa: GridColDef = {
  field: 'tipo_pessoa',
  headerName: 'Tipo pessoa',
  width: 160,
};

export const ColumnVinculoPessoa: GridColDef = {
  field: 'vinculo_pessoa',
  headerName: 'Vínculo pessoa',
  width: 180,
};

export const ColumnTelefone: GridColDef = {
  field: 'telefone',
  headerName: 'Telefone',
  width: 500,
};

export const ColumnEmail: GridColDef = {
  field: 'email',
  headerName: 'E-mail',
  width: 500,
};

export const ColumnContato: GridColDef = {
  field: 'contato',
  headerName: 'Contato',
  width: 500,
};

export const ColumnEndereco: GridColDef = {
  field: 'endereco',
  headerName: 'Endereço',
  width: 500,
};

export const ColumnObservacao: GridColDef = {
  field: 'obs',
  headerName: 'Observação',
  width: 500,
};

export const ColumnInformacao1: GridColDef = {
  field: 'inf1',
  headerName: 'Informação 1',
  width: 500,
};

export const ColumnInformacao2: GridColDef = {
  field: 'inf2',
  headerName: 'Informação 2',
  width: 500,
};

export const ColumnInformacao3: GridColDef = {
  field: 'inf3',
  headerName: 'Informação 3',
  width: 500,
};

export const ColumnInformacao4: GridColDef = {
  field: 'inf4',
  headerName: 'Informação 4',
  width: 500,
};

export const ColumnInformacao5: GridColDef = {
  field: 'inf5',
  headerName: 'Informação 5',
  width: 500,
};

export const ColumnID: GridColDef = {
  field: 'access_key',
  headerName: '#',
  width: 400,
  hide: true,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};
